import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import useFetch, {CachePolicies} from "use-http";
import style from "./addFriendPopup.module.css";
import {friendIcon} from "./friends.utils.props";
import {Modal} from "antd";
import {AppContext} from "src/pages/context/App.context";
import ButtonCenterClose from "src/components/shared/button/CloseButton/ButtonCenterClose";
import MemberProfile from "./MemberProfile";
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import styles from "../../Home/CreatePost/CreatePost.module.scss";

const AddFriendPopup = (props: any) => {
    const { close } = props;

    enum REQUEST_STATUS {
        EMPTY,
        NONE,
        HAS_REQUESTED,
        PENDING,
    }

    const findUserProfiles = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "api/v1/users/finds",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const { t } = useTranslation();
    const appCtx: any = useContext(AppContext);
    const [searchKey, setSearchKey] = useState("");
    const [found, setFound] = useState(false);
    const [isFriend, setIsFriend] = useState(false);
    const [requestStatus, setRequestStatus] = useState(REQUEST_STATUS.EMPTY);
    const [acceptText, setAcceptText] = useState("");
    const [cancelText, setCancelText] = useState("");
    const [findFriend, setFindFriend]: any = useState(null);
    const [searching, setSearching] = useState(false);
    const [more, setMore] = useState(false);

    const callLimit = 20;

    const handleChange = (event: any) => {
        setSearchKey(event.target.value);
        setFound(false);
        setIsFriend(false);
        setRequestStatus(REQUEST_STATUS.EMPTY);
        setAcceptText("");
        setCancelText("");
        setFindFriend([])
        // setFriendID("");
        setSearching(false);

    };

    const handleSearch = (event: any) => {
        if (event.key === "Enter") {
            console.log("Enter");
            getProfile(searchKey);
        }
    };

    const checkHasMore = (currentTotal: number, total: number) => {
        if (currentTotal + callLimit >= total) setMore(false);
    };

    const fetchNextFindsFriend = async () => {
        console.log("loading more...");

        checkHasMore(findFriend?.data?.length, findFriend?.total);

        setTimeout(async () => {
            if (findFriend?.data?.length < findFriend?.total) {
                const comingData = await findUserProfiles.get(
                    `?search=${searchKey}&limit=${callLimit}&offset=${findFriend?.data?.length}`
                );
                setFindFriend((prev: any) => {
                    const newData = {
                        data: [...prev.data, ...comingData.data],
                        total: prev.total,
                    };
                    return newData;
                });
            }
        }, 500);
    };

    const checkIsMore = () => {
        if (findFriend !== null) {
            if (findFriend.data?.length == findFriend.total) {
                setMore(false);
            } else {
                setMore(true);
            }
        }
    };

    useEffect(() => {
        checkIsMore();
        if (findFriend !== null) {
            console.log("findFriend loaded: ", findFriend);
        }
    }, [findFriend]);

    const getProfile = async (value: any) => {
        console.log("profile value ::>>", value);
        let res = await findUserProfiles.get(`?search=${value}&limit=${callLimit}`);
        console.log("profile res ::>>", res);
        let ls: any = [];

        if (res.data.length !== 0 && res.code !== 500) {
            setFound(true);
            ls = res;
        } else {
            setSearching(false);
        }
        setFindFriend(ls);
    };

    useEffect(() => {
        if (!searchKey) return;
        if (searchKey.length < 5) return;
        getProfile(searchKey);
    }, [searchKey])

    return (
        <Modal
            centered
            visible={props.show}
            className={styles.modalOveride}
            onCancel={close}
        >
            {/*<div className={style.alphaBackground}>*/}
            <div className={style.popupContainer}>
                <div className={style.popupHeader}>
                    <div className={style.header}>{t("Add friend")}</div>
                    <div>
                        <ButtonCenterClose onClick={close} />
                    </div>
                </div>

                <div className={style.searchContainer}>
                    <div
                        className={style.searchIcon}
                        style={{ backgroundImage: `url(${friendIcon.searchIcon})` }}
                    />
                    <input
                        type="text"
                        className={style.searchInput}
                        placeholder={t("Search")}
                        value={searchKey}
                        onChange={handleChange}
                        onKeyPress={handleSearch}
                    />
                </div>

                {!found ? (
                    <div className={style.notFound}>
                        {searching ? t("Searching") : t("not found")}
                    </div>
                ) : null}


                <div id="findPersonContainer"
                    style={{
                        height: "100%",
                        width: "100%",
                        overflow: "auto",
                        marginTop: "20px",
                        marginBottom: "20px",
                        overflowX: "hidden"
                    }}
                    className={style.scrollbarContainer}>
                    <InfiniteScroll
                        dataLength={findFriend == null ? 0 : findFriend.data?.length}
                        next={fetchNextFindsFriend}
                        hasMore={more}
                        scrollableTarget={"findPersonContainer"}
                        loader={
                            !more ? null : (
                                <SkeletonTheme color="#E3E3E3" highlightColor="#EEEEEE">
                                    <div
                                        style={{
                                            padding: "0px 23px 36px 23px",
                                        }}
                                    >
                                        <div style={{ textAlign: "center" }}>
                                            <Skeleton
                                                count={1}
                                                style={{
                                                    width: " 21.5rem",
                                                    height: "230px",
                                                    marginBottom: "10px",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </SkeletonTheme>
                                // </div>
                            )
                        }
                    >
                        {found ? findFriend.data?.map((item: any, idx: number) => {
                            return (
                                <MemberProfile
                                    key={idx}
                                    item={item}
                                    close={close}
                                    friend={searchKey}
                                    setFound={setFound}
                                    getProfile={getProfile}
                                />
                            )
                        }) : null}
                    </InfiniteScroll>
                </div>

            </div>
            {/*</div>*/}
        </Modal >
    );
};

export default AddFriendPopup;
